module.exports = __webpack_public_path__ + "img/avatar-girl.9752ea7e.png";